/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Email of the assigned agent
 * @export
 * @interface AgentEmail
 */
export interface AgentEmail {
}

/**
 * Check if a given object implements the AgentEmail interface.
 */
export function instanceOfAgentEmail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AgentEmailFromJSON(json: any): AgentEmail {
    return AgentEmailFromJSONTyped(json, false);
}

export function AgentEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentEmail {
    return json;
}

export function AgentEmailToJSON(value?: AgentEmail | null): any {
    return value;
}

